import React, { useEffect } from "react";
import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import Navigation from "../../../../../components/navigations/client/detail/contacts/navigation";
import { NavigationHistoryService } from "../../../../../services/navigation-history-service";

export default () => {
  const { _case } = useParentLoaderData(2);

  useEffect(() => {
    const navService = new NavigationHistoryService();
    navService.save("client-detail", "/contacts/law-firm");
  }, []);

  return (
    <Navigation activeTab="law-firm" _case={_case}>
      Law Firm
    </Navigation>
  );
}; 